export enum RouteName {
  List = 'reason-code-management',
  Id = 'reason-code-management-id',
}
